import { render } from "./SheetHeader.vue?vue&type=template&id=bf09c214&ts=true"
import script from "./SheetHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SheetHeader.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sheet/SheetHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf09c214"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf09c214', __exports__)) {
    api.reload('bf09c214', __exports__)
  }
  
  module.hot.accept("./SheetHeader.vue?vue&type=template&id=bf09c214&ts=true", () => {
    api.rerender('bf09c214', render)
  })

}


export default __exports__